import { IBudgetPreference } from '@/types';

export class BudgetPreference implements IBudgetPreference {
	constructor(
		public readonly currency?: string,
		public readonly yearlyTuitionFee?: number,
		public readonly monthlyLivingCosts?: number,
	) {}
}
